/**
 * @generated SignedSource<<9f9a7515ec61f09a3a9f0b2b55d1afaf>>
 * @relayHash df4be2654ee1a577d38c4a8cb8b57384
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60aadd2677d791263cc3b5535e337283885b463f99989f9522eb767a51f7c5ee

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CalendarContentQuery } from './CalendarContentQuery.graphql';

import isJiraAiAgentAvatarCalendarViewEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-calendar-view.relayprovider';

const node: PreloadableConcreteRequest<CalendarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "60aadd2677d791263cc3b5535e337283885b463f99989f9522eb767a51f7c5ee",
    "metadata": {},
    "name": "CalendarContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarcalendarviewrelayprovider": isJiraAiAgentAvatarCalendarViewEnabled_provider
    }
  }
};

export default node;
